import React, { useState } from "react";
import "../../../../../styles/CustomCalendar.css";

const CustomCalendar = ({ selectedDate, handleDateSelect }) => {
  const [currentMonth, setCurrentMonth] = useState(new Date());

  const getDaysInMonth = (month, year) =>
    new Date(year, month + 1, 0).getDate();

  const handlePrevMonth = () => {
    const prevMonth = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() - 1,
      1
    );
    setCurrentMonth(prevMonth);
  };

  const handleNextMonth = () => {
    const nextMonth = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() + 1,
      1
    );
    setCurrentMonth(nextMonth);
  };

  const handleDateClick = (date) => {
    handleDateSelect(date);
  };

  const renderDaysOfWeek = () => {
    const daysOfWeek = ["일", "월", "화", "수", "목", "금", "토"];
    return (
      <div className="calendar-days-of-week">
        {daysOfWeek.map((day, index) => (
          <div key={index} className="day-of-week">
            {day}
          </div>
        ))}
      </div>
    );
  };

  const renderDates = () => {
    const daysInMonth = getDaysInMonth(
      currentMonth.getMonth(),
      currentMonth.getFullYear()
    );
    const firstDayOfMonth = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth(),
      1
    ).getDay();

    const dates = [];
    for (let i = 0; i < firstDayOfMonth; i++) {
      dates.push(<div key={`empty-${i}`} className="calendar-date empty" />);
    }

    for (let i = 1; i <= daysInMonth; i++) {
      const date = new Date(
        currentMonth.getFullYear(),
        currentMonth.getMonth(),
        i,
        23,
        59,
        59
      );
      const isSelected = selectedDate?.toDateString() === date.toDateString();
      dates.push(
        <div
          key={i}
          className={`calendar-date ${isSelected ? "selected" : ""}`}
          onClick={() => handleDateClick(date)}
        >
          {i}
        </div>
      );
    }

    return <div className="calendar-dates">{dates}</div>;
  };

  return (
    <div className="custom-calendar">
      <div className="calendar-header">
        <button onClick={handlePrevMonth}>&lt;</button>
        <div>
          {currentMonth.getFullYear()}년 {currentMonth.getMonth() + 1}월
        </div>
        <button onClick={handleNextMonth}>&gt;</button>
      </div>
      {renderDaysOfWeek()}
      {renderDates()}
    </div>
  );
};

export default CustomCalendar;
